import BaseService from '../baseServices';
import REST from '../../configs/rest';

const uploadMedia = (params = {}) => {
  const data = new FormData();
  data.append('file', params?.file);
  data.append('access_token', params?.access_token);
  data.append('ad_account_id', params?.ad_account_id);
  return BaseService.post(REST.FACEBOOK_UPLOAD_AD_IMAGE, data);
};

export default { uploadMedia };
